import api from "./api";

// Process Category service (CRUD)
// GET    /process-category
// GET    /process-category/:id
// POST   /process-category
// PATCH  /process-category/:id
// DELETE /process-category/:id

export async function getProcessCategories() {
  const res = await api.get("/process-category");
  return Array.isArray(res) ? res : [];
}

export async function getProcessCategoryById(categoryId) {
  if (categoryId === undefined || categoryId === null || categoryId === "") {
    throw new Error("categoryId is required");
  }
  const idNum = Number(categoryId);
  if (!Number.isInteger(idNum)) throw new Error("categoryId must be an integer");
  return api.get(`/process-category/${idNum}`);
}

export async function createProcessCategory(payload) {
  return api.post("/process-category", payload || {});
}

export async function updateProcessCategory(categoryId, payload) {
  const idNum = Number(categoryId);
  if (!Number.isInteger(idNum)) throw new Error("categoryId must be an integer");
  const body = { ...(payload || {}) };
  delete body.id;
  return api.patch(`/process-category/${idNum}`, body);
}

export async function deleteProcessCategory(categoryId) {
  const idNum = Number(categoryId);
  if (!Number.isInteger(idNum)) throw new Error("categoryId must be an integer");
  return api.delete(`/process-category/${idNum}`);
}
